// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { bargainBinProductInfoStyles } from "@awc/App/Components/BargainBin/BargainBinProductInfo";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

bargainBinProductInfoStyles.container = {
    css: css`
        margin-top: 32px;
        margin-bottom: 20px;
    `,
};
bargainBinProductInfoStyles.attributesTable = {
    css: css`
        border: 1px solid ${color("common.ui31")};
        tr {
            border-bottom: 1px solid ${color("common.ui26")};
            td:last-child {
                border-left: 1px solid ${color("common.ui26")};
                text-align: left;
            }

            &:nth-child(even) {
                background: ${color("common.white")};
            }
            &:nth-child(odd) {
                background: ${color("common.border")};
            }
        }
    `,
};
bargainBinProductInfoStyles.productInfo = {
    css: css`
        display: grid;
        grid-template-columns: 180px 1fr;
        grid-column-gap: 16px;
        margin-bottom: 32px;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr 4fr;
        }
        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr 2fr;
        }
    `,
};

bargainBinProductInfoStyles.dataCells = {
    mergeCss: true,
    css: css`
        border: none;
    `,
};

bargainBinProductInfoStyles.bottomSection = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px 16px;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};
